"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.formatDateTimeFull = formatDateTimeFull;
var fullMonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function formatAmPm(date) {
  var hours = date.getHours();
  var amPm = hours >= 12 ? 'pm' : 'am';
  var amPmUpperCase = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  return {
    hours: hours,
    amPm: amPm,
    amPmUpperCase: amPmUpperCase
  };
}

/**
 *
 * @param targetTimeZone
 * @param date
 * @param format
 * @return {string}
 */
function formatDateTimeFull(_ref) {
  var date = _ref.date,
    _ref$targetTimeZone = _ref.targetTimeZone,
    targetTimeZone = _ref$targetTimeZone === void 0 ? '' : _ref$targetTimeZone,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'hh:min dd/mm/yyyy' : _ref$format;
  var result = new Date(date);
  if (targetTimeZone !== '') {
    result = new Date(result.toLocaleString('en-US', {
      timeZone: targetTimeZone
    }));
  }
  var _formatAmPm = formatAmPm(result),
    hours = _formatAmPm.hours,
    amPm = _formatAmPm.amPm,
    amPmUpperCase = _formatAmPm.amPmUpperCase;
  var formatMap = {
    a: amPm,
    A: amPmUpperCase,
    yyyy: result.getFullYear(),
    mm: ('0' + (result.getMonth() + 1)).slice(-2),
    dd: ('0' + result.getDate()).slice(-2),
    hh: ('0' + result.getHours()).slice(-2),
    h: ('0' + hours).slice(-2),
    min: ('0' + result.getMinutes()).slice(-2),
    ss: ('0' + result.getSeconds()).slice(-2),
    mmm: monthList[result.getMonth()],
    mmmm: fullMonthList[result.getMonth()]
  };
  return format.replace(/yyyy|mmmm|mmm|mm|dd|hh|h|min|ss|a(?!t)|A(?!t)/g, function (match) {
    return formatMap[match];
  });
}
function formatDate(date) {
  var d = new Date(date);
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return [year, month, day].join('-');
}
function formatDateTime(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (format) {
    return formatDate(new Date(date));
  }
  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric'
  });
}